const development = false;

export const settings = {
    baseURL:  development ? "http://localhost:4000" :"https://api.cobija-erp.biz",
    apiURL:  development ? "http://localhost:4000/api/v1" :"https://api.cobija-erp.biz/api/v1",
}
